export default __webpack_public_path__ + "static/media/web_fading_engagement.4391c384.svg";